import { MessagesProvider } from '../contexts/MessagesContext';
import { ExportPDFPage } from './ExportPDFPage';

export const ExportPDFPageWrapper = ({ isShare = false }) => {
  return (
    <MessagesProvider isShare={isShare}>
      <ExportPDFPage isShare={isShare} />
    </MessagesProvider>
  )
}